<span [style.background-color]="bgColor" class="xvi-tag-renderer" [style.color]="fontColor">{{ tagName | translate }}</span>
